import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { unstable_batchedUpdates } from 'react-dom';
import Select from 'react-select';
import Card from "../../../Components/Card/Card";
import Exports from "../../../Components/Exports/Exports";
import { useComun } from '../../../Hooks/useComun';
import useLogin from '../../Autenticacion/Hooks/useLogin';
import CardIndicador from "../Components/CardIndicador";
import notfound from '../../../Assets/images/il-empty.svg';
import { ObtenerIndicadoresSerieService } from '../Services/ObtenerIndicadoresSerieService';
import { EnumModuloDesc, EnumPathRutas } from "../../../Utils/Enumeradores/ComunEnum";
import { useRegistroTDR } from '../../../Hooks/useRegistroTDR';
import { ListaPeriodosCalculosService } from '../../Indicadores/Services/ListaPeriodosCalculosService';
import { BuscaSerieIndicadorService } from '../../Indicadores/Services/BuscaSerieIndicadorService';
import { ObtenerListaIndicadorDtService } from '../../Indicadores/Services/ObtenerListaIndicadorDtService';

const DatamartSelectOption = (props) => {
	const { innerProps, isSelected, label } = props;

	return (
		<div {...innerProps} className={`datamart-filter-toolbar__option ${isSelected ? 'is-selected' : ''}`}>
			<span className="datamart-filter-toolbar__radio" aria-hidden="true"></span>
			<span>{label}</span>
		</div>
	);
};

const DatamartIndicadoresPage = () => {
	const location = useLocation();
	const { crearRegistroTDR } = useRegistroTDR();
	const { user, usuario } = useLogin();
	const { downloadCSV } = useComun();
	const [listadoIndicadoresSerie, setListadoIndicadoresSerie] = useState([]);
	const [listadoPeriodos, setListadoPeriodos] = useState([]);
	const [listadoIndicadoresDt, setListadoIndicadoresDt] = useState([]);
	const [periodoSeleccionado, setPeriodoSeleccionado] = useState({ ano: "", mes: "" });
	const [periodoAplicado, setPeriodoAplicado] = useState(null);
	const [cargaInicialFinalizada, setCargaInicialFinalizada] = useState(false);
	const datosPage = { indicador: location.state ? location.state.indicador : null, siglaIndicador: location.state ? location.state.sigla : "", descripcionIndicador: location.state ? location.state.descripcion : "" };
	const idUsuario = user?.id || usuario?.id;
	const indicadorHistoricoId = listadoIndicadoresDt.find((item) => item.sigla === datosPage.siglaIndicador)?.indicadorId || datosPage.indicador;

	const anosPeriodo = [...new Set(listadoPeriodos.map((item) => item.ano))]
		.sort((a, b) => b - a);

	const anosPeriodoOptions = anosPeriodo.map((ano) => ({
		value: ano,
		label: ano
	}));

	const mesesPeriodo = listadoPeriodos
		.filter((item) => item.ano === Number(periodoSeleccionado.ano))
		.sort((a, b) => a.mes - b.mes);

	const mesesPeriodoOptions = mesesPeriodo.map((item) => ({
		value: item.mes,
		label: item.nombreMes
	}));

	const datamartSelectComponents = {
		Option: DatamartSelectOption
	};

	const obtenerPeriodoMasReciente = (periodos = []) => {
		if (periodos.length === 0) {
			return null;
		}

		return [...periodos].sort((a, b) => {
			if (b.ano !== a.ano) {
				return b.ano - a.ano;
			}

			return b.mes - a.mes;
		})[0];
	};

	const obtenerUltimoMesPorAno = (ano) => {
		const periodosAno = listadoPeriodos.filter((item) => item.ano === Number(ano));
		return obtenerPeriodoMasReciente(periodosAno);
	};

	const obtenerFechaCierrePeriodo = (ano, mes) => {
		if (!ano || !mes) {
			return null;
		}

		return new Date(Number(ano), Number(mes), 0, 23, 55, 0);
	};

	const mapBuscaSerieIndicadorResponse = (data = []) => {
		return data.flatMap((serie) =>
			(serie.indicador || []).map((indicador) => ({
				...indicador,
				descripcionSerie: serie.periodo || serie.serieDescripcion,
				idSerie: serie.serieId,
				nivelCumplimientoId: indicador.nivelCumplimientoId || indicador.nivelCumplimientoID,
				fecha: indicador.fecha || indicador.fechaHoraCreacion || obtenerFechaCierrePeriodo(serie.ano, serie.mes)
			}))
		);
	};

	async function postListaPeriodosCalculosService() {
		const resp = await ListaPeriodosCalculosService({ idUsuario });
		if (resp && resp.status === 200 && Array.isArray(resp.data)) {
			setListadoPeriodos(resp.data);
		}
	}

	async function postObtenerListaIndicadorDtService() {
		const resp = await ObtenerListaIndicadorDtService({
			idUsuario,
			idPerfilContexto: usuario.perfilContexto.id
		});

		if (resp && resp.status === 200 && Array.isArray(resp.data)) {
			setListadoIndicadoresDt(resp.data);
		}
	}

	async function postObtenerIndicadoresSerieService(values) {
		const resp = await ObtenerIndicadoresSerieService(values);
		if (resp) {
			if (resp.status === 200) {
				if (resp.data) {
					if (!values.exportacion) {
						setListadoIndicadoresSerie(resp.data);
					} else {
						downloadCSV(resp.data, location.state.sigla, EnumModuloDesc.DescargaDatamart);
					}
				}
			}
		}
	}

	async function postBuscaSerieIndicadorService(values) {
		const resp = await BuscaSerieIndicadorService(values);
		if (resp && resp.status === 200 && Array.isArray(resp.data)) {
			return mapBuscaSerieIndicadorResponse(resp.data);
		} else if (resp && resp.status === 206) {
			return [];
		}

		return null;
	}

	useEffect(() => {
		if (location.state) {
			const startTime = new Date();
			const formEnvio = {
				idUsuario,
				indicadorSigla: location.state.sigla,
				exportacion: false
			}

			const fetchData = async () => {
				try {
					await Promise.all([
						postListaPeriodosCalculosService(),
						postObtenerListaIndicadorDtService()
					]);
					await postObtenerIndicadoresSerieService(formEnvio);
					const endTime = new Date();
					const tdrId = 16;
					crearRegistroTDR(startTime, endTime, usuario, tdrId);
				} finally {
					setCargaInicialFinalizada(true);
				}
			};

			fetchData();
		}
	}, [])

	function cambiarAno(option) {
		const ano = option ? option.value : "";
		const ultimoMes = obtenerUltimoMesPorAno(ano);

		setPeriodoSeleccionado({
			ano,
			mes: ultimoMes ? ultimoMes.mes : ""
		});
	}

	function cambiarMes(option) {
		setPeriodoSeleccionado((prevState) => ({
			...prevState,
			mes: option ? option.value : ""
		}));
	}

	async function aplicarFiltros(e) {
		e.preventDefault();

		if (!periodoSeleccionado.ano || !periodoSeleccionado.mes) {
			return;
		}

		const mesSeleccionado = mesesPeriodoOptions.find((option) => option.value === Number(periodoSeleccionado.mes));
		const periodoHistorico = `${periodoSeleccionado.ano}-${periodoSeleccionado.mes}`;
		const formEnvio = {
			idUsuario,
			indicadorId: indicadorHistoricoId ? [indicadorHistoricoId] : [],
			serieId: [],
			idPerfilContexto: usuario.perfilContexto.id,
			consultaIndicadores: true,
			periodosHistoricos: [periodoHistorico]
		};

		try {
			const resultado = await postBuscaSerieIndicadorService(formEnvio);
			unstable_batchedUpdates(() => {
				if (resultado !== null) {
					setListadoIndicadoresSerie(resultado);
					setPeriodoAplicado({
						ano: periodoSeleccionado.ano,
						mes: periodoSeleccionado.mes,
						nombreMes: mesSeleccionado ? mesSeleccionado.label : ""
					});
				}
			});
		} catch {
			return;
		}
	}

	async function limpiarPeriodoAplicado() {
		if (location.state) {
			const formEnvio = {
				idUsuario,
				indicadorSigla: location.state.sigla,
				exportacion: false
			};

			try {
				const resp = await ObtenerIndicadoresSerieService(formEnvio);
				unstable_batchedUpdates(() => {
					if (resp && resp.status === 200 && resp.data) {
						setListadoIndicadoresSerie(resp.data);
					}
					setPeriodoAplicado(null);
					setPeriodoSeleccionado({ ano: "", mes: "" });
				});
			} catch {
				return;
			}
		}
	}

	function descargar(tipo) {
		const formEnvio = {
			idUsuario,
			indicadorSigla: location.state.sigla,
			exportacion: true
		}
		postObtenerIndicadoresSerieService(formEnvio);
	}

	return (
		<div className="container-fluid">
			<div className="row mb-4">
				<div className="col-12">
					<div className="breadcrumbs">
						<ul>
							<li><Link to={EnumPathRutas.Inicio}> Inicio</Link></li>
							<li><Link to={EnumPathRutas.Datamart}> Datamart</Link></li>
							<li><a href="#"></a></li>
						</ul>
					</div>
				</div>
			</div>
			<div className="row">
				<div className="col-12">
					<Card className={`p-4 datamart-indicadores-card ${!cargaInicialFinalizada ? "datamart-indicadores-card--loading" : ""}`}>
						<div className="d-flex justify-content-between align-items-start mb-5 gap-3 flex-wrap">
							<span className='d-flex flex-column'>
								<h3 className="fs-3">{datosPage ? datosPage.siglaIndicador : ""}</h3>
								<span className="text-pewter-blue d-block">{datosPage ? datosPage.descripcionIndicador : ""}</span>
								{periodoAplicado &&
									<span className="datamart-applied-filter mt-3">
										<span className="datamart-applied-filter__label">{periodoAplicado.ano} - {periodoAplicado.nombreMes}</span>
										<button type="button" className="datamart-applied-filter__close" onClick={limpiarPeriodoAplicado} aria-label="Limpiar filtro">
											<i className="ico-close"></i>
										</button>
									</span>
								}
							</span>
							<form className="datamart-filter-toolbar d-flex align-items-start flex-wrap" onSubmit={aplicarFiltros}>
								<div className="form-floating">
									<div className="simple-select datamart-filter-toolbar__select">
										<label htmlFor="field-datamart-ano">Año</label>
										<Select
											classNamePrefix="selector"
											inputId="field-datamart-ano"
											name="datamartAno"
											options={anosPeriodoOptions}
											value={anosPeriodoOptions.find((option) => option.value === Number(periodoSeleccionado.ano)) || null}
											onChange={cambiarAno}
											placeholder="Seleccionar"
											noOptionsMessage={() => "Sin opciones"}
											isDisabled={anosPeriodoOptions.length === 0}
											isSearchable={false}
											components={datamartSelectComponents}
										/>
									</div>
								</div>
								<div className="form-floating">
									<div className="simple-select datamart-filter-toolbar__select">
										<label htmlFor="field-datamart-mes">Mes</label>
										<Select
											classNamePrefix="selector"
											inputId="field-datamart-mes"
											name="datamartMes"
											options={mesesPeriodoOptions}
											value={mesesPeriodoOptions.find((option) => option.value === Number(periodoSeleccionado.mes)) || null}
											onChange={cambiarMes}
											placeholder="Seleccionar"
											noOptionsMessage={() => "Sin opciones"}
											isDisabled={mesesPeriodoOptions.length === 0}
											isSearchable={false}
											components={datamartSelectComponents}
										/>
									</div>
								</div>
								<button type="submit" className="btn btn-primary datamart-filter-toolbar__button">
									Aplicar
								</button>
								{listadoIndicadoresSerie.length > 0 &&
									<>
										<span className="datamart-filter-toolbar__divider" aria-hidden="true"></span>
										<Exports descargar={(tipo) => descargar(tipo)} helpers="datamart-filter-toolbar__export" />
									</>
								}
							</form>
						</div>
						<div className="datamart-results">
							{listadoIndicadoresSerie.length > 0 ?
								<div className="row flex-wrap">
									{
										listadoIndicadoresSerie.map((item, i) => {
											return (
												<div key={i} className={periodoAplicado ? "col-12 mb-4" : "col-12 col-md-4 col-lg-3 mb-4"}>
													<CardIndicador key={i} item={item} datosIndicador={datosPage} variant={periodoAplicado ? "wide" : "default"} />
												</div>
											)
										})
									}
								</div>
								:
								cargaInicialFinalizada &&
									<div className="d-flex justify-content-center align-items-center flex-column gap-2 py-5">
										<img className="mb-3" src={notfound} alt="" />
										<p className='mb-0 text-primary'>No se encuentran resultados de tu b&uacute;squeda.</p>
									</div>
							}
						</div>
					</Card>
				</div>
			</div>
		</div>
	)
}

export default DatamartIndicadoresPage;
